import { render, staticRenderFns } from "./AnnouncementScreen.vue?vue&type=template&id=eac12b62"
import script from "./AnnouncementScreen.vue?vue&type=script&lang=js"
export * from "./AnnouncementScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports